import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Komponente für rollenbasierte Zugriffssteuerung
 * Zeigt die Komponente nur an, wenn der Benutzer die benötigten Rechte hat
 * 
 * @param {Object} props
 * @param {Array|String} props.requiredRoles - Rolle(n) die für den Zugriff notwendig sind
 * @param {React.Component} props.element - Die anzuzeigende Komponente
 * @param {String} props.redirectPath - Umleitungspfad bei fehlendem Zugriff
 */
const RoleRoute = ({ requiredRoles, element, redirectPath = '/app' }) => {
  const { user, hasAnyRole, hasRole } = useAuth();
  const location = useLocation();
  
  if (!user) {
    // Benutzer ist nicht angemeldet, Umleitung zur Login-Seite.
    // WICHTIG: "/login" (AuthPage), NICHT "/auth" - der Pfad /auth existiert in
    // der App gar nicht und ist im nginx als Proxy zu FusionAuth belegt. Wer aus
    // einer Willkommensmail auf /dashboard/admin klickt, ohne angemeldet zu sein,
    // landete dadurch auf einer weissen Seite und beim Neuladen auf 502
    // Bad Gateway (Sep 2026). Jede andere Weiche in App.js zeigt auf /login.
    // state.from: AuthPage springt nach dem Login zurück, wenn utils/returnPath.js
    // den Pfad erlaubt (z. B. /dashboard/teacher aus einem Link im KI-Chat).
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  
  // Prüfe, ob der Benutzer die erforderlichen Berechtigungen hat
  const hasAccess = Array.isArray(requiredRoles) 
    ? hasAnyRole(requiredRoles) 
    : hasRole(requiredRoles);
  
  if (!hasAccess) {
    // Benutzer hat keine Berechtigung, Umleitung zur Standard-Seite
    return <Navigate to={redirectPath} replace />;
  }
  
  // Zeige die Komponente an, wenn Zugriff gewährt
  return element;
};

export default RoleRoute;